export default function ProductsSection() {
  const products = [
    {
      brand: "Nike",
      label: "Dunk Low",
      img: "https://readdy.ai/api/search-image?query=Nike%20Dunk%20Low%20on%20yellow%20gradient%20background%2C%20vibrant%20color%20pop%2C%20dynamic%20angle%20shot%2C%20bold%20product%20photography%2C%20bright%20studio%20lighting%2C%20energetic%20sneaker%20display%2C%20modern%20urban%20style&width=400&height=400&seq=prod-v2-nike&orientation=squarish",
    },
    {
      brand: "Jordan",
      label: "Air Jordan 4",
      img: "https://readdy.ai/api/search-image?query=Air%20Jordan%204%20midnight%20navy%20on%20dark%20concrete%20with%20red%20accent%20lighting%2C%20dramatic%20shadow%20play%2C%20basketball%20court%20vibe%2C%20premium%20sneaker%20photography%2C%20moody%20atmospheric%20lighting&width=400&height=400&seq=prod-v2-jordan&orientation=squarish",
    },
    {
      brand: "Adidas",
      label: "Samba OG",
      img: "https://readdy.ai/api/search-image?query=Adidas%20Samba%20on%20grass%20field%20with%20sunset%20golden%20hour%20backlight%2C%20outdoor%20lifestyle%20shot%2C%20warm%20natural%20tones%2C%20casual%20authentic%20feel%2C%20editorial%20sports%20photography&width=400&height=400&seq=prod-v2-adidas&orientation=squarish",
    },
    {
      brand: "Yeezy",
      label: "Boost 350",
      img: "https://readdy.ai/api/search-image?query=Yeezy%20350%20on%20minimal%20white%20pedestal%20with%20dramatic%20top%20lighting%2C%20clean%20futuristic%20aesthetic%2C%20sharp%20shadows%2C%20gallery%20display%20style%2C%20premium%20product%20photography%2C%20sculptural%20presentation&width=400&height=400&seq=prod-v2-yeezy&orientation=squarish",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white/60 text-xs font-medium mb-4">
              Populares
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white leading-tight">
              Produtos Mais<br />
              Procurados
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {products.map((p) => (
            <div
              key={p.label}
              className="bg-transparent rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="aspect-square rounded-xl overflow-hidden mb-3">
                <img
                  src={p.img}
                  alt={`Hoobuy Spreadsheet - ${p.brand} ${p.label}`}
                  title={`${p.brand} ${p.label} na Hoobuy Spreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="px-1">
                <p className="text-white/45 text-xs uppercase tracking-wide mb-1">{p.brand}</p>
                <p className="text-white font-semibold text-sm">{p.label}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-3 mt-10">
          {["Nike", "Jordan", "Adidas", "Yeezy", "Supreme", "Essentials"].map((brand) => (
            <span
              key={brand}
              className="px-5 py-2.5 rounded-full border border-white/15 text-white/70 text-xs font-medium hover:border-white/45 hover:text-white transition-colors cursor-pointer"
            >
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}